import { React, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

export default function ResetPassword() {
  // const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/stock");
    }
  });

  const isConfirmed = (password, passwordConfirmation) => {
    return password === passwordConfirmation;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (isConfirmed) {
      setError("E-mail invalide");
    }

    try {
      const response = await axios.post(
        "http://localhost:8080/api/reset-password",
        {
          password,
        }
      );

      navigate("/login");
    } catch (err) {
      // Gérer les erreurs
      if (err.response) {
        // Erreur renvoyée par le backend
        setError(
          err.response.data.message ||
            "Une erreur s'est produite lors de l'envoie du mail"
        );
      } else if (err.request) {
        // Pas de réponse du serveur
        setError("Le serveur ne répond pas. Veuillez réessayer plus tard.");
      } else {
        // Autres erreurs
        setError("Une erreur est survenue. Veuillez réessayer.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    setPasswordVisibility(!passwordVisibility);
    const password = document.getElementById("password");
    if (passwordVisibility) {
      password.type = "password";
      password.placeholder = "••••••••••••";
    } else {
      password.type = "text";
      password.placeholder = "Mot de passe";
    }
  };

  return (
    <div className="w-full max-w-md max-sm:max-w-sm p-4 sm:p-6 md:p-8 my-16 mx-auto rounded-md z-30 shadow-lg border border-gray-200">
      <form className="space-y-4" onSubmit={handleSubmit}>
        <h5 className="text-3xl font-bold text-gray-900">
          {"Réinitialisation du mot de passe"}
        </h5>
        {error && (
          <p className="text-red-500 bg-red-200 px-4 py-2 rounded-md">
            {error}
          </p>
        )}
        {!error && (
          <p className=""> Veuillez entrer votre nouveau mot de passe</p>
        )}
        <div className="relative">
          <label
            htmlFor="password"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Votre mot de passe
          </label>
          <input
            type="password"
            name="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••••••"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-400 focus:border-amber-400 block w-full p-2.5"
            required
          />
          <span
            className="absolute top-1/2 right-2 text-gray-500 hover:text-gray-900 cursor-pointer"
            onClick={handleClick}
          >
            <svg
              className={["w-6 h-6", passwordVisibility ? "" : "hidden"].join(
                " "
              )}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="m4 15.6 3.055-3.056A4.913 4.913 0 0 1 7 12.012a5.006 5.006 0 0 1 5-5c.178.009.356.027.532.054l1.744-1.744A8.973 8.973 0 0 0 12 5.012c-5.388 0-10 5.336-10 7A6.49 6.49 0 0 0 4 15.6Z" />
              <path d="m14.7 10.726 4.995-5.007A.998.998 0 0 0 18.99 4a1 1 0 0 0-.71.305l-4.995 5.007a2.98 2.98 0 0 0-.588-.21l-.035-.01a2.981 2.981 0 0 0-3.584 3.583c0 .012.008.022.01.033.05.204.12.402.211.59l-4.995 4.983a1 1 0 1 0 1.414 1.414l4.995-4.983c.189.091.386.162.59.211.011 0 .021.007.033.01a2.982 2.982 0 0 0 3.584-3.584c0-.012-.008-.023-.011-.035a3.05 3.05 0 0 0-.21-.588Z" />
              <path d="m19.821 8.605-2.857 2.857a4.952 4.952 0 0 1-5.514 5.514l-1.785 1.785c.767.166 1.55.25 2.335.251 6.453 0 10-5.258 10-7 0-1.166-1.637-2.874-2.179-3.407Z" />
            </svg>

            <svg
              className={["w-6 h-6", passwordVisibility ? "hidden" : ""].join(
                " "
              )}
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fillRule="evenodd"
                d="M4.998 7.78C6.729 6.345 9.198 5 12 5c2.802 0 5.27 1.345 7.002 2.78a12.713 12.713 0 0 1 2.096 2.183c.253.344.465.682.618.997.14.286.284.658.284 1.04s-.145.754-.284 1.04a6.6 6.6 0 0 1-.618.997 12.712 12.712 0 0 1-2.096 2.183C17.271 17.655 14.802 19 12 19c-2.802 0-5.27-1.345-7.002-2.78a12.712 12.712 0 0 1-2.096-2.183 6.6 6.6 0 0 1-.618-.997C2.144 12.754 2 12.382 2 12s.145-.754.284-1.04c.153-.315.365-.653.618-.997A12.714 12.714 0 0 1 4.998 7.78ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                clipRule="evenodd"
              />
            </svg>
          </span>
        </div>

        <div className="relative">
          <label
            htmlFor="passwordConfirmation"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Confirmez votre mot de passe
          </label>
          <input
            type="passwordConfirmation"
            name="passwordConfirmation"
            id="passwordConfirmation"
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            placeholder="••••••••••••"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-400 focus:border-amber-400 block w-full p-2.5"
            required
          />
        </div>
        <div className="">
          <Link
            to="/login"
            className="ms-auto text-sm text-amber-600 hover:underline "
          >
            Se connecter
          </Link>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full text-white bg-amber-600 hover:bg-amber-700 focus:ring-4 focus:outline-none focus:ring-amber-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
        >
          {loading ? (
            <div className="flex justify-center items-center">
              <div className="w-5 h-5 border-2 border-t-amber-600 rounded-full animate-spin"></div>
            </div>
          ) : (
            "Mettre à jour le mot de passe"
          )}
        </button>
      </form>
    </div>
  );
}
